module.exports = __webpack_public_path__ + "img/green_blob.9c4462ef.png";